module.exports = __webpack_public_path__ + "img/SALASKO RACING.9fcd9ad.jpg";